import { Alert as FlowbiteAlert } from "flowbite-react";
export { FlowbiteAlert as Alert };